import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PostCycleCountsMutationVariables = Types.Exact<{
  input: Types.PostCycleCountsInput;
}>;


export type PostCycleCountsMutation = { __typename?: 'Mutation', postCycleCounts: { __typename?: 'CycleCountPayload', success: boolean, itemsPosted: number, cycleCount?: { __typename?: 'CycleCountLogDocument', id: string, locationId: string, locationName: string, recordedBy: string, postedAt: Types.TDateISO, itemCount: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };


export const PostCycleCountsDocument = new TypedDocumentString(`
    mutation PostCycleCounts($input: PostCycleCountsInput!) {
  postCycleCounts(input: $input) {
    cycleCount {
      id
      locationId
      locationName
      recordedBy
      postedAt
      itemCount
    }
    errors {
      ...RecordValidationError
    }
    success
    itemsPosted
  }
}
    fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    PostCycleCounts: build.mutation<PostCycleCountsMutation, PostCycleCountsMutationVariables>({
      query: (variables) => ({ document: PostCycleCountsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { usePostCycleCountsMutation } = injectedRtkApi;
